/**
 * Copyright (c) 2019 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import PropTypes from 'prop-types';

const detailsCard = ({
  picture,
  content = [],
  // actions = [],
  cardId = ''
}) => (
  <div id={cardId} className="details-card">
    <div className="details-card-picture">
      <img src={picture} />
    </div>
    <div className="details-card-content">
      {content.map(({ label, value }) => (
        <div key={label} className="details-card-content-field">
          <span className="details-card-content-field-label">{label}</span>
          <span className="details-card-content-field-value">{value}</span>
        </div>
      ))}
    </div>
    <div className="details-card-actions">{/* action buttons may be added in the future */}</div>
  </div>
);

detailsCard.propTypes = {
  picture: PropTypes.any,
  content: PropTypes.array,
  actions: PropTypes.array,
  cardId: PropTypes.string
};
export default detailsCard;
